<template>
  <div class="position-relative" >
    <b-row>
      <b-col>
        <document-upload  @uploadSuccess="fetchList" :ObjectId="ObjectId"
                        :DocumentTypeId="DocumentTypeId"></document-upload>
      </b-col>
    </b-row>

<!--    <b-row class="mt-3">
      <b-col cols="8">
        <b-table :items="galleryListComputed">

        </b-table>
      </b-col>
    </b-row>-->


      <draggable v-model="galleryListComputed" @change="changeOrder" class="row">
        <DocumentItem ref="galleryItem"
                     :key="img.id" v-for="(img, imgIndex) in galleryListComputed"
                     @imageClicked="index=imgIndex"
                     @textfieldEdit="updateTextfield($event, img.id)"
                     @removeDocument="removeItemFromList(img.id)"
                      @downloadDoc="downloadItem(img.id)"
                     :checkboxSelectedList="selectedDocumentList"
                     :disabled="actionState"
                     :DocumentTypeId="DocumentTypeId"
                     :item="img">
        </DocumentItem>
      </draggable>




  </div>
</template>

<script>

  import  DocumentUpload from '@/components/applicant/document/DocumentUpload'
  import DocumentItem from '@/components/applicant/document/DocumentItem'
  import {getDocumentList, deleteDocument, deleteDocumentList,downloadListOfDocuments,downloadDocument, updateDocumentName} from "@/services/document";
  import {toast} from "@/shared/plugins/toastr";
  import VueGallery from 'vue-gallery';
  import draggable from 'vuedraggable'
  import SaveButton from '@/components/app/AppSubmit'

    export default {
        name: "DocumentsPreview",
      props:{
          ObjectId:{
            type:Number
          },
        DocumentTypeId:{
          type:Number
        },

        galleryList:{
          type:Array
        }

      },
      data(){
        return{
          selectedDocumentList: [],
          galleryListFull:[],
          tag_sidebar_state: false,
          actionState: false,
          textEdited: false,
        }
      },
      components:{
          VueGallery,
        DocumentUpload,
        DocumentItem,
        draggable,
        SaveButton
      },
      computed:{
        disabledActionBarItem() {
          return this.selectedDocumentList.length === 0
        },
        galleryListComputed: {
          get() {
            return this.galleryListFull
          },
          set(value) {
            this.galleryListFull = value
          }
        },
      },
      methods:{

        downloadSelected() {
          this.actionState = true

          downloadListOfDocuments(this.ObjectId, this.DocumentTypeId, this.selectedDocumentList).then(() => {
            this.actionState = false
            this.selectedDocumentList = []
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'type': 'success',
              'timeout': 3000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
            this.actionState = false
          })

        },
        deleteSelected() {
          this.actionState = true
          deleteDocumentList(this.ObjectId, this.DocumentTypeId, this.selectedDocumentList).then(response => {
            this.galleryListFull = response.data
            this.selectedDocumentList = []
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'type': 'success',
              'timeout': 3000
            })
            this.actionState = false
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
            this.actionState = false
          })
        },
        selectAll() {

          this.$refs.gallery_dropdown_action.hide(false)
          if (this.selectedDocumentList.length === this.galleryListFull.length) {
            this.selectedDocumentList = []
          } else {
            this.galleryListFull.forEach(element => {
              if (!this.selectedDocumentList.includes(element.id)) {
                this.selectedDocumentList.push(element.id)
              }
            })
          }
        },
        fetchList() {
          getDocumentList(this.ObjectId, this.DocumentTypeId).then((response) => {
            this.galleryListFull = response.data
          })
        },
        changeOrder(data) {
          this.submit(false)
        },
        updateList(data) {
          this.galleryListFull = data
        },
        updateTextfield(value, id) {
          setTimeout(function () {
            updateDocumentName(id, {document_name:value})
          }, 1000)

        },
        removeItemFromList(id) {
          deleteDocument(this.ObjectId, this.DocumentTypeId, id).then((response) => {
              this.galleryListFull = response.data
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 3000
              })
            }, error => {
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                'type': 'error',
                'timeout': 6000
              })
            }
          )
        },
        downloadItem(id){
          downloadDocument(this.ObjectId, this.DocumentTypeId, id).then(()=>{

          }, error=>{
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          })
        }
      },
      watch: {
        ObjectId: {
          handler() {
            this.fetchList()
          },
          immediate: true
        }
      },

    }
</script>

<style scoped>

</style>
